import { Component, input, Signal } from '@angular/core';
import { BaseViewComponent, Field, Scope } from '@sb/library/base';

export class LoadingSpinnerScope extends Scope {
  sideNavOpen? = Field<Signal<boolean>>();
}

@Component({
  selector: 'lib-loading-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class LoadingSpinnerComponent extends BaseViewComponent {

  Scope = this.SetScope({Requires: LoadingSpinnerScope});

  readonly qaTag = input<string>();
  /** When false, the spinner is positioned within its containing element instead of fixed to the viewport. */
  readonly fullPage = input<boolean>(true);

}
